import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=4e3cfc73&scoped=true&"
import script from "./Dummy.vue?vue&type=script&lang=ts&"
export * from "./Dummy.vue?vue&type=script&lang=ts&"
import style0 from "./Dummy.vue?vue&type=style&index=0&id=4e3cfc73&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cfc73",
  null
  
)

export default component.exports